import React from 'react';

const SvgZw = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="ZW_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="ZW_svg__c">
        <stop stopColor="#F12F1F" offset="0%" />
        <stop stopColor="#DE2010" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="ZW_svg__b" fill="#fff">
        <use xlinkHref="#ZW_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#ZW_svg__a" />
      <path
        fill="#369D0C"
        mask="url(#ZW_svg__b)"
        d="M0 0h28v2.667H0zM0 17.333h28V20H0zM0 5.333h28V8H0zM0 12h28v2.667H0z"
      />
      <path fill="#262626" mask="url(#ZW_svg__b)" d="M0 8h28v4H0z" />
      <path
        fill="#FFD40E"
        mask="url(#ZW_svg__b)"
        d="M0 2.667h28v2.667H0zM0 14.667h28v2.667H0z"
      />
      <path
        d="M-.667 19.333h.445L12.222 10-.222.667h-.445v18.666z"
        stroke="#262626"
        strokeWidth={1.333}
        fill="#FFF"
        mask="url(#ZW_svg__b)"
      />
      <path
        fill="url(#ZW_svg__c)"
        mask="url(#ZW_svg__b)"
        d="M4 11.3l-1.96 1.397.724-2.295L.83 8.97l2.406-.022L4 6.667l.764 2.281 2.406.022-1.934 1.432.723 2.295z"
      />
    </g>
  </svg>
);

export default SvgZw;
